import React, { Component } from "react";
import $ from "jquery";

import { connect } from "react-redux";

import { loadMap, updateSize } from "store/modules/rds_sisMap";

import { FaMapMarkerAlt } from "react-icons/fa";
//import { closeRoadView }  from 'components/map/header/menu/mapMenu';

import "./map.scss";

class Map extends Component {
	componentDidMount() {
		this.props.loadMap({
			id: "map",
			scaleId: "ol-scale",
			zoomSlider: true,
			isCenterPosition: true,
			x: this.props.x,
			y: this.props.y,
			z: this.props.z,
		});

		if (this.props.sis.category) {
			$(`.leftWrap #${this.props.sis.category}`).click();
		}
	}

	render() {
		return (
			<>
				<div className={`${this.props.className}`}>
					<div id="map" className="">
						<div className="mapNumber">
							<span id="mapNum1">영상1 (2023년)</span>
						</div>
					</div>
					<div id="subMap2" className="sisSubMap">
						<div className="mapNumber">
							<span id="mapNum2">영상2 (2023년)</span>
						</div>
					</div>
					<div id="subMap3" className="sisSubMap">
						<div className="mapNumber">
							<span id="mapNum3">영상3 (2023년)</span>
						</div>
					</div>
					<div id="subMap4" className="sisSubMap">
						<div className="mapNumber">
							<span id="mapNum4">영상4 (2023년)</span>
						</div>
					</div>

					<div id="mapNumber">
						<span>영상1</span>
						<span>영상2</span>
						<span>영상3</span>
						<span>영상4</span>
					</div>

					<div id="daumMap" style={{ display: "none" }}></div>
					<div className="footer">
						<span>
							- 지적도를 포함한 모든 주제도는 참고용으로만 사용하시기 바랍니다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Copyright ⓒ2025 전남광주통합특별시,국토지리정보원. All
							Rights Reserved
						</span>
					</div>

					<div className="footer mobile">
						<span>
							지적도를 포함한 모든 주제도는 참고용으로만 사용하시기 바랍니다. <br />
							Copyright ⓒ2025 전남광주통합특별시,국토지리정보원. All Rights Reserved
						</span>
					</div>
				</div>
				<div className="roadViewClose" >
						X
				</div> 
				<div id="roadViewWrap">
				</div>
				<div className="sisMapWalker">
					<div className="angleBack"></div>
					<div className="figure"></div>
				</div>

				<div id="searchOverlayWrap">
					<FaMapMarkerAlt size="25" />
					<span id="searchOverlayTitle">타이틀</span>
				</div>
			</>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
		
	}),
	(dispatch) => ({
		updateSize: (payload) => dispatch(updateSize(payload)),
		loadMap: (payload) => dispatch(loadMap(payload)),
		//closeRoadView: (payload) => dispatch(closeRoadView(payload)),
	})
)(Map);
